/**
 * THE OTHER NAME A FIGURE IS KNOWN BY, when it is worth writing beside the one being shown.
 *
 * Theirs writes both in a search row — "Joseph / Yusuf", "Jonah / Yunus", "Job / Ayyub" — and ours
 * wrote the English alone. A reader who knows a figure by one tradition's spelling meeting the other
 * one here is most of what this library is for.
 *
 * IT IS A RULE RATHER THAN AN EXPRESSION IN A COMPONENT, because it has a case that is easy to get
 * wrong and impossible to see in a screenshot of the common one. 67 of the 1,099 carry a second
 * name and the canonical name ALREADY says both for some of them — "Enoch / Idris", "Abraham's
 * father (Terah / Azar)". Appended blindly those become "Enoch / Idris / Idris".
 *
 * The bundle also spells "no other name" two ways, absent and present-but-blank, and both mean the
 * same thing here.
 */
export function otherName(name: string, other: string | null | undefined): string | undefined {
  const second = (other ?? '').trim();
  if (second === '') return undefined;
  /* Case-folded, because the two spellings are not always capitalised the same way. */
  if (name.toLowerCase().includes(second.toLowerCase())) return undefined;
  return second;
}
